import { watch } from 'vue'
import { useAuthStore } from '@/features/account/session'
import { useCharactersStore } from '@/stores/characters'
import { useLorebooksStore } from '@/stores/lorebooks'
import { useConversationsStore } from '@/stores/conversations'

/** Catalogs own their data; identity transitions retire their in-memory lifetime. */
export function useCatalogSessions() {
  const auth = useAuthStore()
  const catalogs = [useCharactersStore(), useLorebooksStore(), useConversationsStore()]
  watch(() => auth.userId, id => {
    for (const catalog of catalogs) catalog.setAccount(id)
  }, { immediate: true, flush: 'sync' })
}
